import { grey } from "@mui/material/colors";

const styles = {
  toggle: {
    textTransform: "none",
    border: "none",
    borderRadius: "20px !important",
    px: { xs: 1, md: 2 },
    py: { xs: 0.5, md: 1 },
    "&.Mui-selected": {
      backgroundColor: "#fff",
      color: "#000",
      "&:hover": { backgroundColor: "#fff" },
    },
    "&:hover": { backgroundColor: "#f1f1f1" },
    fontSize: { xs: 10, md: 13 },
  },
  drawer: {
    "& .MuiDrawer-paper": {
      position: "absolute",
      right: "-8px",
      boxShadow: "-8px 0px 16px rgba(0, 0, 0, 0.1)", // ← soft shadow
    },
  },
  toggleGroup: {
    backgroundColor: "#f8f8f6",
    borderRadius: "24px",
    p: 0.5,
  },
  card: {
    border: `1px solid #ECEAE5`,
    p: 2,
    borderRadius: "10px",
    position: "relative",
  },
  editButtonWrapper: {
    position: "absolute",
    right: "8px",
    top: "12px",
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  editButton: {
    fontSize: 14,
    color: grey[500],
  },
  editIcon: {
    fontSize: 14,
    color: grey[500],
  },
  closeIcon: {
    position: "absolute",
    right: "8px",
    top: "12px",
    fontSize: 18,
    color: grey[400],
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      color: "primary.main",
      textDecoration: "underline",
    },
  },
};

export default styles;
